/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PublicApiRequestAudit } from "./PublicApiRequestAudit";
import {
  PublicApiRequestAuditFromJSON,
  PublicApiRequestAuditFromJSONTyped,
  PublicApiRequestAuditToJSON,
  PublicApiRequestAuditToJSONTyped,
} from "./PublicApiRequestAudit";

/**
 *
 * @export
 * @interface PublicApiRequestPage
 */
export interface PublicApiRequestPage {
  /**
   *
   * @type {Array<PublicApiRequestAudit>}
   * @memberof PublicApiRequestPage
   */
  requests: Array<PublicApiRequestAudit>;
  /**
   *
   * @type {number}
   * @memberof PublicApiRequestPage
   */
  totalCount: number;
  /**
   *
   * @type {number}
   * @memberof PublicApiRequestPage
   */
  page: number;
  /**
   *
   * @type {number}
   * @memberof PublicApiRequestPage
   */
  pageSize: number;
}

/**
 * Check if a given object implements the PublicApiRequestPage interface.
 */
export function instanceOfPublicApiRequestPage(
  value: object,
): value is PublicApiRequestPage {
  if (!("requests" in value) || value["requests"] === undefined) return false;
  if (!("totalCount" in value) || value["totalCount"] === undefined)
    return false;
  if (!("page" in value) || value["page"] === undefined) return false;
  if (!("pageSize" in value) || value["pageSize"] === undefined) return false;
  return true;
}

export function PublicApiRequestPageFromJSON(json: any): PublicApiRequestPage {
  return PublicApiRequestPageFromJSONTyped(json, false);
}

export function PublicApiRequestPageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PublicApiRequestPage {
  if (json == null) {
    return json;
  }
  return {
    requests: (json["requests"] as Array<any>).map(
      PublicApiRequestAuditFromJSON,
    ),
    totalCount: json["totalCount"],
    page: json["page"],
    pageSize: json["pageSize"],
  };
}

export function PublicApiRequestPageToJSON(json: any): PublicApiRequestPage {
  return PublicApiRequestPageToJSONTyped(json, false);
}

export function PublicApiRequestPageToJSONTyped(
  value?: PublicApiRequestPage | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    requests: (value["requests"] as Array<any>).map(
      PublicApiRequestAuditToJSON,
    ),
    totalCount: value["totalCount"],
    page: value["page"],
    pageSize: value["pageSize"],
  };
}
